export const SALESFORCE_API_URL =
  "https://api.arcteryx-routes.com/salesforce-leads";
